import { ModulePermission } from "../interfaces/permission";

export const TEMPORARYPERMISSION:ModulePermission[]=[
    {
      "iParentFeatureId": 2001,
      "vParentFeature": "Home",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2002,
      "vParentFeature": "Customer Profile",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2003,
      "vParentFeature": "Activities",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2004,
      "vParentFeature": "Users",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2005,
      "vParentFeature": "Quotations & Proposals",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2006,
      "vParentFeature": "Projects",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2007,
      "vParentFeature": "BOM",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2008,
      "vParentFeature": "Assets",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2009,
      "vParentFeature": "Change Requests",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2010,
      "vParentFeature": "File Storage",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2011,
      "vParentFeature": "Production",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2012,
      "vParentFeature": "Shipping",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2013,
      "vParentFeature": "Inventory",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2014,
      "vParentFeature": "Escalations",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2015,
      "vParentFeature": "Risks",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2016,
      "vParentFeature": "Feedback",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2017,
      "vParentFeature": "Invoice",
      "iModuleStatus": 1,
      "hasChild": true
    },
    {
      "iParentFeatureId": 2018,
      "vParentFeature": "Warranty",
      "iModuleStatus": 1,
      "hasChild": true
    }
  ];